import ProjHouse from './proj-house'

export default ProjHouse